// import "babel-polyfill"; // 外部引入polyfill解决ie下dropdown闪烁问题
import "intersection-observer";
import Vue from "vue";
import App from "./app.vue";
import router from "./router";
import store from "./store";
// import Antd from "ant-design-vue";
import "../static/reset.less";

// require("./mock.js");

import {
  Spin,
  Layout,
  Button,
  Modal,
  Input,
  Icon,
  message,
  Radio,
  Dropdown,
  Badge,
  Select,
  InputNumber,
  Upload,
  Checkbox,
  Tree,
  Row,
  Col,
  List,
  FormModel,
  Menu,
  ConfigProvider
} from "ant-design-vue";

if (!!window.ActiveXObject || "ActiveXObject" in window) {
  Input.methods.handleReset = function() {
    this.stateValue = "";
    this.$emit("change.value", "");
    this.$emit("change", "");
    this.$emit("input", "");
  };
}

import "@/assets/icons";
import Directive from "@/utils/directive";
Vue.use(Directive);
import moment from "moment";
import "moment/locale/zh-cn";
import "@/utils/tools";
moment.locale("zh-cn");

import i18n from "./i18n";

Vue.config.productionTip = false;

Vue.use(Layout);
Vue.use(Radio);
Vue.use(Spin);
Vue.use(Button);
Vue.use(Modal);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Dropdown);
Vue.use(Icon);
Vue.use(Badge);
Vue.use(Select);
Vue.use(Upload);
Vue.use(Checkbox);
Vue.use(Tree);
Vue.use(Row);
Vue.use(Col);
Vue.use(List);
Vue.use(FormModel);
Vue.use(Menu);
Vue.use(ConfigProvider);

Vue.prototype.$message = message;
Vue.prototype.$info = Modal.info;
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$error = Modal.error;
Vue.prototype.$message.config({
  top: `70px`,
  duration: 1
});
Vue.prototype.$eventHub = Vue.prototype.$eventHub || new Vue();
const consoleStyle = `color: #1b3ef7;
    font-weight: bold;
    font-size: 16px;
    text-shadow: 0.5px 0.5px 1px #409eff`;
console.info(`%c Version:${process.env.VUE_APP_VERSION}`, consoleStyle);

window.IS_SHOW_LOG = process.env.VUE_APP_SHOWLOG === "true";

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
